import SSOLogin from './ssoLogin.vue'

export default {
  name: 'ssoLoginPage',
  path: '/v-admin/hm/sso-login',
  component: SSOLogin,
  meta: {
    noAuth: true,
    titleI18nKey: 'hm.dashboard.title'
  }
}
